// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { Box, Card, IconButton, Typography } from '../../lib/base';
import { ArrowDownwardIcon } from '../../lib/icons';

interface Props {
  readonly title: string;
  readonly count: number;
  readonly anchor: string;
}

export default React.memo(function OverdueCard({ title, count, anchor }: Props) {
  const hasOverdue = count > 0;
  const cardColor = hasOverdue ? 'red' : 'green';
  const goTo = () => document.querySelector(`#${anchor}`)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <Card
      sx={{ borderLeft: `5px solid ${cardColor}`, cursor: hasOverdue ? 'pointer' : undefined }}
      onClick={hasOverdue ? goTo : undefined}
    >
      <Box
        sx={{
          padding: 2,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography variant="h5" component="div" style={{ color: cardColor }}>
          {count} {title}
        </Typography>
        {hasOverdue && (
          <IconButton>
            <ArrowDownwardIcon />
          </IconButton>
        )}
      </Box>
    </Card>
  );
});
